// @flow
import type {Element, Node} from 'react'
import React from 'react'

import Close from 'components/ui/icons/md/Close'
import Add from 'components/ui/icons/md/Add'
import Pencil from 'components/ui/icons/fa/Pencil'
import MovingIn from 'components/ui/icons/general/MovingIn'
import MovingOut from 'components/ui/icons/general/MovingOut'
import classNames from 'classnames'

export type ListItemType = 'adding' | 'removing' | 'changing' | 'movingIn' | 'movingOut'

type Props = {
  children: Node,
  type: ?ListItemType,
}

function ListItem({children, type}: Props): Element<"div"> {
  const base = 'proposal-summary-list-item'

  const itemTitleClasses = classNames('proposal-summary-list-item__title')

  const classAndIconMap = {
    changing: ['changing', Pencil],
    adding: ['adding', Add],
    removing: ['removing', Close],
    movingIn: ['moving-in', MovingIn],
    movingOut: ['moving-out', MovingOut],
  }

  const [classSuffix, Icon] = classAndIconMap[type || 'changing']

  return (
    <div className="proposal-summary-list-item">
      <div className={`${base}__icon ${base}__icon--${classSuffix}`}>
        <Icon />
      </div>
      <div className={itemTitleClasses}>
        {children}
      </div>
    </div>
  )
}

export default ListItem
